import React from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import ContactPage from "../../../subsreens/gcstudent/ContactUs/ContactPage";
import HeroSection from "../../../components/gcstudent/aboutsection/HeroSection";
// import GcStudentContactUs from "../../../subscreens/gcstudent/ContactUs/GcStudentContactUs";
const GcContact = () => {
    const ContactData = { title: 'Contact', highLight: 'Us', subTitle: 'Have questions or need help? Reach out to us and we will get back to you shortly.' };

    return (
        <>
            <GcStudentMasterLayout>
                <HeroSection  heroData={ ContactData}/>
                <ContactPage/>
            </GcStudentMasterLayout>
        </>
    );
};

export default GcContact;